import { get, writable } from 'svelte/store';
import { app } from "./firebase";
import { createBusiness, _deleteBusinessesOfOwner, createUserDoc, _deleteCardSettingsOfOwner, _deleteDevicesOfOwner } from "./firestore";
import {
    getAuth,
    onAuthStateChanged,
    reload,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    updateProfile,
    updateEmail,
    sendEmailVerification,
    sendPasswordResetEmail,
    updatePassword,
    reauthenticateWithCredential,
    EmailAuthProvider,
    deleteUser,
    getIdToken,
    getIdTokenResult
} from "firebase/auth";
import { collection, doc, onSnapshot, query, where, limit, deleteField, updateDoc, serverTimestamp, getDoc, orderBy, setDoc } from 'firebase/firestore';
import { db } from "./firestore";

export const authenticated = writable(undefined);
export const admin = writable(undefined);
export const user = writable(undefined);
export const business = writable(undefined);
export const subscription = writable(undefined);
export const previouslyLoggedIn = writable(true); // TODO: save in localStorage
export const businessNames = writable({});
export const blockedTimeframes = writable({});
export let cardsCollection;

export const auth = getAuth(app);

onAuthStateChanged(auth, (_user) => {
    if (_user) {
        authenticated.set(true);
        updateClaims(_user);
        getBusinessData(_user);
        cardsCollection = cardsStore(_user.uid);
        user.set(_user);
    } else {
        authenticated.set(false);
        admin.set(false);
        subscription.set(undefined);
        user.set(undefined);
        business.set(undefined);
    }
});


export async function updateClaims(user) {
    // getIdToken(auth.currentUser, true);
    const idToken = await getIdTokenResult(user, true);
    admin.set(idToken.claims.admin);
    subscription.set(idToken.claims.stripeRole || false);
}


export async function getBusinessData(user) {
    const businessesRef = collection(db, "businesses");
    const q = query(businessesRef, where("owner", "==", user.uid), limit(1));
    const unsub = onSnapshot(q, (snap) => {
        snap.forEach((doc) => {
            let _business = doc.data();
            _business.id = doc.id;
            _business.address = _business.address ?? {};
            _business.images = _business.images ?? {};
            _business.openingHours = _business.openingHours ?? {};
            business.set(_business);
        });
    })
}


export async function saveChanges(properties) {
    console.log("saving business Data");
    let _business = get(business);
    if (!(_business.name && _business.address?.city && _business.address?.houseNumber && _business.address?.street && _business.address?.zip && _business.address?.state?.name && _business.address?.state?.id)) {
        _business.visible = false;
        properties.push("visible");
    } else if (_business.wasVisibleBefore && !properties.includes("visible")) {
        _business.visible = true;
        properties.push("visible");
    }
    const data = {};
    properties.forEach((prop) => {
        const props = prop.split(".");
        const value = getValueFromNestedObject(_business, props);
        // if the value of the data we're wanting to save is empty or undefined, delete it
        data[prop] = value !== undefined && value !== "" ? value : deleteField();
    })
    data.updated = serverTimestamp();
    let docRef = doc(db, "businesses", _business.id);
    try {
        return updateDoc(docRef, data);
    } catch (error) {
        alert ("Es ist ein Fehler beim Speichern aufgetreten. Bitte prüfe ob alle deine Eingaben gültig sind.");
        throw (error);
    }
}

function getValueFromNestedObject (object, keys) {
    return keys.reduce(
        (obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined,
        object
    );
}


export function refresh () {
    return reload(auth.currentUser)
    .then(() => {
        authenticated.set(true);
        user.set(auth.currentUser);
    })
}


export async function _signUp (email, password, displayName) {
    try {
        // TODO: handle errors better. What if UserDoc can't be added?
        await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(auth.currentUser, {
            displayName,
        });
        auth.currentUser.displayName = displayName; // doing this so it's updated locally without the need to refresh the whole user
        await setDoc(doc(db, "images", auth.currentUser.uid), {});
        await createBusiness(auth.currentUser.uid);
        await sendEmailVerification(auth.currentUser);
    } catch (error) {
        alert(error)
        return error;
    }
}


export async function _updateEmail (currentPassword, newEmail) {
    const credential = EmailAuthProvider.credential(auth.currentUser.email, currentPassword);
    try {
        await reauthenticateWithCredential(auth.currentUser, credential)
        await updateEmail(auth.currentUser, newEmail);
        await sendEmailVerification(auth.currentUser);
        refresh();
    } catch (error) {
        throw error;
    }
}


export function _sendEmailVerification() {
    return sendEmailVerification(auth.currentUser);
}


export function _sendPasswordResetEmail(email) {
    return sendPasswordResetEmail(auth, email)
}


export async function _updatePassword(currentPassword, newPassword) {
    const credential = EmailAuthProvider.credential(auth.currentUser.email, currentPassword);
    try {
        await reauthenticateWithCredential(auth.currentUser, credential);
        await updatePassword(auth.currentUser, newPassword);
    } catch (error) {
        throw error;
    }
}


export async function _deleteUser(currentPassword) {
    const credential = EmailAuthProvider.credential(auth.currentUser.email, currentPassword);
    try {
        await reauthenticateWithCredential(auth.currentUser, credential);
        await _deleteBusinessesOfOwner(auth.currentUser.uid);
        await _deleteCardSettingsOfOwner(auth.currentUser.uid);
        await _deleteDevicesOfOwner(auth.currentUser.uid)
        await deleteUser(auth.currentUser);
    } catch (error) {
        console.log(error);
        throw error;
    }
}


export async function getBusinessName(id) {
    let _businessNames = get(businessNames);

    if (_businessNames[id]) {
        console.log("Name was already stored locally");
        return _businessNames[id]
    }
    
    console.log("Getting name from Firebase");
    const businessRef = doc(db, "businesses", id);
    const businessDoc = await getDoc(businessRef);
    const name = businessDoc.data().name;
    _businessNames[id] = name;
    businessNames.set(_businessNames);
    return (name)
}


export function cardsStore(uid) {
    let unsubscribe = () => {};
  
    const q = query(collection(db, "cardSettings"), where("owner", "==", uid), orderBy("start"));
    const { subscribe } = writable(undefined, (set) => {
        console.log("asdasd");
        unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((s) => {
            return { id: s.id, ref: s.ref, ...s.data() };
            });
            set(data);
        });
    
        return () => unsubscribe();
    });
  
    return {
        subscribe
    };
}